import React from "react";
import { Routes, Route } from "react-router-dom";

/* 🌍 Public Pages */
import Home from "./pages/Home";
import SearchPage from "./pages/SearchPage";
import AboutPage from "./pages/AboutPage";
import EditionPage from "./pages/EditionPage";
import IndividualPage from "./pages/IndividualPage";
import MySpacePage from "./pages/MySpacePage";
import MySpaceIndividual from "./pages/MySpaceIndividual";

/* 🔧 Components */
import Separate from "./components/Separate";
import Login from "./components/Login";
import MySpaceSubmitForm from "./components/MySpaceSubmitForm";
import ProtectedRoute from "./components/ProtectedRoute";

/* 🔒 Admin Pages */
import Dashboard from "./backend/Dashboard";
import ArticlesPanel from "./backend/ArticlesPanel";
import EditionsAdmin from "./backend/EditionsAdmin";
import MySpacePanel from "./backend/MySpacePanel";
import AdminRequests from "./backend/AdminRequests";
import MagazineAdmin from "./backend/MagazineAdmin";

export default function AppRoutes() {
  return (
    <Routes>
      {/* 🌍 PUBLIC ROUTES */}
      <Route path="/" element={<Home />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/login" element={<Login />} />

      <Route path="/individual/:id" element={<IndividualPage />} />
      <Route path="/category/:type" element={<Separate />} />
      <Route path="/separate" element={<Separate />} />

      {/* MySpace Routes */}
      <Route path="/myspace" element={<MySpacePage />} />
      <Route path="/myspace/:id" element={<MySpaceIndividual />} />
      <Route path="/myspaceclient" element={<MySpaceSubmitForm />} />

      <Route path="/editions" element={<EditionPage />} />
      <Route path="/status" element={<MagazineAdmin />} />

      {/* 🔒 PROTECTED ADMIN ROUTES */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/articlespanel"
        element={
          <ProtectedRoute>
            <ArticlesPanel />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editionsadmin"
        element={
          <ProtectedRoute>
            <EditionsAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminrequest"
        element={
          <ProtectedRoute>
            <AdminRequests />
          </ProtectedRoute>
        }
      />
      <Route
        path="/myspacepanel"
        element={
          <ProtectedRoute>
            <MySpacePanel />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
